import { defineComponent } from "vue";
import SmeLayout from "../../layouts/SmeLayout";
import SmeSupportForm from "../../components/SmeSupportForm";

export default defineComponent({
    components: {
        SmeLayout,
        SmeSupportForm,
    },

    template: `
        <SmeLayout class="StepSmeProsumer">
            <h1 class="title-1 mt-0">Wygląda na to, że produkujesz własną energię</h1>

            <div class="SmeSupportFormBox contentbox contentbox--white">
                <h2 class="title-2">Nasz Doradca może przygotować dla Ciebie ofertę</h2>

                <SmeSupportForm type="prosumer">
                    <p class="SmeSupportFormBox__text">W tej chwili nie posiadamy ofert online dla prosumentów. Wypełnij formularz, a nasz Doradca skontaktuje się z Tobą najszybciej jak to możliwe.</p>
                </SmeSupportForm>
            </div>
        </SmeLayout>
    `,

    emits: [
        'offers'
    ],

    props: {
    },

    setup(props, ctx) {
        return {
        };
    },
});
